import { Location } from "@/interfaces/location";
import { Stems } from "@/interfaces/stems";
import { StemsLocations, StemsMock } from "@/metadata/stems";
import HttpService from "./http.service";

const stemsMock = StemsMock;

class StemsService extends HttpService {
  public async getStems(id: number | null): Promise<Stems | null> {
    return stemsMock.find(stem => stem.id === id) || null;
  }

  public async updateStems(stems: Stems) {
    const index = stemsMock.findIndex(x => x.id === stems.id);
    stemsMock[index] = stems;
  }

  public async getLocations(): Promise<Array<Partial<Location>>> {
    return StemsLocations;
  }
}

export const stemsService = new StemsService();
